import React from "react";
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import Obfuscate from "react-obfuscate";
import { FaEnvelopeO, FaTwitter, FaGithub, FaLinkedin } from "react-icons/lib/fa/";
import Helmet from "react-helmet";

export default props => {
  return (
    <div className="c-content-box">
      <Helmet title="About me" />

      <HeadlineWithFocus>
       <span> Who am </span> I
      </HeadlineWithFocus>
      <p>From a musician to software engineer, I am a tech enthusiast with passion for art and programming. Besides building full-stack apps I am a music label owner that loves to produce nice sounds from time to time. </p>
       <HeadlineWithFocus>
       <span> What I </span> love
      </HeadlineWithFocus>
      <p>I love aesthetics, in any shape. A great UI design, beautiful illustrations, well produced sound, photography. I love simple solutions.<br />
      I love CRUD apps. And React reusable components.<br/>
      I love deep ambiental electronic music. I love cycling by the sea.<br/> I love dogs.
      I love being lost in the woods. I love every shade of blue.

 </p><br/><br/>
      <h2
        className={`
        js-action-button-anchor
        c-content-box__subheadline
        c-content-box__subheadline--with-button
      `}
      >
        Contact
      </h2>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/pages/contact.jsx